export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/village/queryPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
          data
        });
      },

      save(data){
          return http.json({
              url: '/paperStatistics/supervisorVillage/saveSupervisor',
              data
          })
      },

      saveSupervisorLine(data){
        return http.json({
            url: '/paperStatistics/supervisorVillage/saveSupervisorLine',
            data
        })
    },

      deleteSupervisor(params){
        return http.json({
            url: '/paperStatistics/supervisorVillage/delete',
            params
        })
    },

      listSupervisor(villageId){
          return http.json({
            url: '/paperStatistics/supervisorVillage/listSupervisor',
            params: {
              'villageId' : villageId
            }
        })
      },

      getSupervisorLine(params){
        return http.json({
          url: `/paperStatistics/supervisorVillage/getSupervisorLine`,
          params
        });
      },
      listLines(params){
        return http.json({
          url: `/paperStatistics/basicLine/list`,
          params
        });
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/supervisor.js